import { apiClient } from './client';

export interface ResetAreaInfo {
  key: string;
  name: string;
  description: string;
  tables: string[];
  destructive: boolean;
}

export interface ResetTableCount { table: string; count: number; }
export interface ResetAreaCount { areaKey: string; areaName: string; tables: ResetTableCount[]; total: number; }
export interface ResetPreview { companyCode: string; areas: ResetAreaCount[]; grandTotal: number; }
export interface ResetBlocked { table: string; reason: string; }
export interface ResetResult { deleted: ResetTableCount[]; blocked: ResetBlocked[]; totalDeleted: number; }

export const demoResetApi = {
  async areas(): Promise<ResetAreaInfo[]> {
    const r = await apiClient.get('/system/demo-reset/areas');
    return r.data?.data ?? [];
  },
  async preview(areaKeys: string[]): Promise<ResetPreview> {
    const r = await apiClient.post('/system/demo-reset/preview', { areaKeys });
    return r.data?.data;
  },
  async execute(areaKeys: string[], confirmation: string): Promise<ResetResult> {
    const r = await apiClient.post('/system/demo-reset/execute', { areaKeys, confirmation });
    return r.data?.data;
  },
};
